module.exports = __webpack_public_path__ + "img/drill1_7-7-2021.70715829.jpg";